import { noop } from 'lodash';

export default function useIosAtt() {
  return {
    requestIosAttPermissions: noop,
  };
}
